import { getAuth, signOut } from 'firebase/auth';
import { Timestamp } from 'firebase/firestore';
import img1 from './img/1.svg'
import img2 from './img/2.svg'
import img3 from './img/3.svg'
import img4 from './img/4.svg'
import img5 from './img/5.svg'

class Backend {
	
	static logout() {
		const auth = getAuth();
		signOut(auth);
	}

	static timestampToDate(timestamp) {
		return new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
	}

	static colorFromMood = ['#923F3F', '#FA784F', '#F0A259', '#6EB854', '#35A171'];

	static moodImages = [img1, img2, img3, img4, img5]
}

export default Backend;